import { ShaderStore } from "@babylonjs/core";
const name = "textureFragmentDeclaration";
const shader = `uniform highp sampler2DArray uTextures;in vec2 vUvs;flat in float depth;`;
ShaderStore.IncludesShadersStore[name] = shader;
export const textureFragmentDeclaration = { name, shader };
//# sourceMappingURL=textureFragmentDeclaration.js.map